(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-fleets', {
                parent: 'entity',
                url: '/tab-fleets?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets.html',
                        controller: 'TabFleetsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    predicates: {},
                    objectClazz: {
                        value: '-1'
                    },
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectClazz: $stateParams.objectClazz
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-fleets-detail', {
                parent: 'tab-fleets',
                url: '/tab-fleets/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-detail.html',
                        controller: 'TabFleetsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFleets', function ($stateParams, TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-fleets-new', {
                parent: 'tab-fleets',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-dialog.html',
                        controller: 'TabFleetsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],        entity: function () {
                        return {
                            fleetName: null,
                            fleetDescription: null,
                            isActive: false,
                            isVisibile: false,
                            id: null
                        };
                    },
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('tab-fleets-edit', {
                parent: 'tab-fleets',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabFleets.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-dialog.html',
                        controller: 'TabFleetsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFleets', function ($stateParams,TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }],
                    domain: ['TabDomains', 'Principal', '$q', function (TabDomains, Principal, $q) {
                        var deferred = $q.defer();
                        Principal.identity().then(function (account) {
                            deferred.resolve(TabDomains.get({id: account.context.id}));
                        });
                        return deferred.promise;
                    }]}

            })
            .state('tab-fleets.delete', {
                parent: 'tab-fleets',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-delete-dialog.html',
                        controller: 'TabFleetsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFleets', function (TabFleets) {
                                return TabFleets.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-fleets', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-fleets-object', {
                parent: 'tab-fleets',
                url: '/{id}/manage-objects',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-fleets/tab-fleets-manage-object.html',
                        controller: 'TabFleetsManageObjectController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFleets');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'TabFleets', function ($stateParams, TabFleets) {
                        return TabFleets.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
